import Svg, { G, Path } from "react-native-svg"

export const MultiLanguage = ({ width, height }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
      <G data-name="Group 7355" transform="translate(-22209 19853)">
        <Path fill="none" d="M0 0H56V56H0z" data-name="Rectangle 2274" transform="translate(22209 -19853)"></Path>
        <G transform="translate(22206.33 -19858.246)">
          <Path
            fill="#24397a"
            d="M32.1 13H9.282A2.282 2.282 0 007 15.282v14.831a2.282 2.282 0 002.282 2.282L12.7 38.1l3.423-5.7H32.1a2.282 2.282 0 002.282-2.282V15.282A2.282 2.282 0 0032.1 13z"
            data-name="Path 2274"
            transform="translate(-.859 -.859)"></Path>
          <Path
            fill="#fff"
            d="M11.845 38.381a1.141 1.141 0 01-.975-.57l-3.137-5.22A3.423 3.423 0 015 29.254V14.423A3.423 3.423 0 018.423 11H31.24a3.423 3.423 0 013.423 3.423v14.831a3.423 3.423 0 01-3.423 3.423H15.912l-3.092 5.134a1.141 1.141 0 01-.975.57zm-3.423-25.1a1.141 1.141 0 00-1.141 1.141v14.832a1.141 1.141 0 001.141 1.141 1.141 1.141 0 01.975.57l2.447 4.056 2.447-4.056a1.141 1.141 0 01.975-.57H31.24a1.141 1.141 0 001.141-1.141V14.423a1.141 1.141 0 00-1.141-1.141z"
            data-name="Path 2275"></Path>
          <Path
            fill="#fff"
            d="M31.407 31.55a1.141 1.141 0 01-1.05-.69l-4.084-9.532-4.084 9.532a1.142 1.142 0 01-2.1-.9l4.4-10.268A1.141 1.141 0 0125.538 19h1.472a1.141 1.141 0 011.044.69l4.4 10.268a1.141 1.141 0 01-1.05 1.592z"
            data-name="Path 2276"
            transform="translate(-6.442 -3.436)"></Path>
          <Path
            fill="#fff"
            d="M30.845 33.282h-5.7a1.141 1.141 0 110-2.282h5.7a1.141 1.141 0 010 2.282z"
            data-name="Path 2277"
            transform="translate(-8.162 -8.591)"></Path>
          <Path
            fill="#fff"
            d="M70.1 43H47.282A2.282 2.282 0 0045 45.282v14.831a2.282 2.282 0 002.282 2.282h15.972l3.423 5.7 3.423-5.7a2.282 2.282 0 002.282-2.282V45.282A2.282 2.282 0 0070.1 43z"
            data-name="Path 2278"
            transform="translate(-17.182 -13.746)"></Path>
          <Path
            fill="#24397a"
            d="M65.817 68.381a1.141 1.141 0 01-.975-.57l-3.092-5.134H46.423A3.423 3.423 0 0143 59.254V44.423A3.423 3.423 0 0146.423 41H69.24a3.423 3.423 0 013.423 3.423v14.831a3.423 3.423 0 01-2.732 3.354l-3.137 5.2a1.141 1.141 0 01-.977.573zm-19.395-25.1a1.141 1.141 0 00-1.141 1.141v14.832a1.141 1.141 0 001.141 1.141h15.973a1.141 1.141 0 01.975.57l2.447 4.056 2.447-4.056a1.141 1.141 0 01.975-.57 1.141 1.141 0 001.141-1.141V44.423a1.141 1.141 0 00-1.141-1.141z"
            data-name="Path 2279"
            transform="translate(-16.323 -12.887)"></Path>
          <Path
            fill="#24397a"
            d="M-13.268-19.512L-14.92-18a4.452 4.452 0 003.82 1.843c2.316 0 3.764-1.414 3.764-3.338v-.1a2.211 2.211 0 00.835.17 2.585 2.585 0 00.766-.119v4.019h2.4V-25.1h1.785v-1.856h-5.518v1.856h1.328v3.526a2.9 2.9 0 01-1.363.29 2.983 2.983 0 01-1.363-.341.356.356 0 01-.1-.068h-.017a1.967 1.967 0 00-.579-.2v-.068a2.346 2.346 0 001.243-2.2c0-1.737-1.328-2.878-3.321-2.878a3.642 3.642 0 00-3.032 1.431l1.5 1.414a1.623 1.623 0 011.465-.852 1.092 1.092 0 011.192 1.124c0 .766-.426 1.311-1.465 1.311h-.6v1.993h.92c1.09 0 1.618.443 1.618 1.175a1.283 1.283 0 01-1.431 1.294 2.553 2.553 0 01-2.195-1.363z"
            data-name="Path 2280"
            transform="translate(49.744 60.753)"></Path>
        </G>
      </G>
    </Svg>
  )
}
